'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.momentMappings = exports.languageMappings = exports.defaultLanguage = undefined;
exports.setupTimezone = setupTimezone;
exports.getValidLocale = getValidLocale;
exports.setManualOverwrites = setManualOverwrites;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultLanguage = exports.defaultLanguage = 'en';

// Keys that should map from one to another specific locale
var languageMappings = exports.languageMappings = {
  nb: 'no-no',
  noNO: 'no-no',
  'zh-tw': 'zh-hk',
  pt: 'pt-br',
  no: 'no-no'
};

var momentMappings = exports.momentMappings = {
  pt: 'pt-br',
  'en-ie': 'en-gb',
  'en-nz': 'en-au',
  'es-co': 'es-do',
  'es-ar': 'es-do',
  'es-mx': 'es',
  de: 'de',
  ja: 'ja',
  'en-gb': 'en-gb',
  'en-in': 'en-au',
  es: 'es',
  'zh-cn': 'zh-cn',
  'zh-hk': 'zh-hk',
  nl: 'nl',
  'en-au': 'en-au',
  'en-ca': 'en-ca',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  'pt-br': 'pt-br',
  sv: 'sv',
  da: 'da',
  pl: 'pl',
  cs: 'cs',
  ko: 'ko',
  no: 'nb',
  'no-no': 'nb',
  noNO: 'nb'
};

function setupTimezone(timezone) {
  if (!_I18n2.default.moment) {
    return;
  }
  if (!timezone || !timezone.id) {
    // If we don't have portal data, then we can't use portalTz and even setting a timezone will cause issues
    // If no timezone data, then we should fall back to userTz
    // Without a timezone setting, portalTz returns undefined. So make portalTz work as userTz
    _I18n2.default.moment.portalTz = _I18n2.default.moment.userTz;
    // Fall back on some timezone to not break I18n.moment.fn.portalTz
    // TO DO - modify I18n.moment.fn.portalTz so that it doesn't break without I18n.timezone
    _I18n2.default.timezone = 'US/Eastern';
    return;
  }

  if (_I18n2.default.manualTimezone) {
    return;
  }

  var timezoneId = timezone.id;

  try {
    if (timezone['moment-data']) {
      if (!_I18n2.default.moment.tz.zone(timezoneId)) {
        _I18n2.default.moment.tz.add(timezoneId + '|' + timezone['moment-data']);
      }
      _I18n2.default.moment.tz(timezoneId);
      _I18n2.default.timezone = timezoneId;
    } else {
      if (Raven) {
        Raven.captureMessage('I18n failed to parse api-verify data: ' + JSON.stringify(portal && portal.timezone));
      }
    }
  } catch (e) {
    console.error('Unable to set up timezone', e);
    if (Raven) {
      Raven.captureException(e);
    }
  }

  _I18n2.default.timezone = _I18n2.default.manualTimezone || window.I18N_RENDERED_TZ || _I18n2.default.timezone;
}

function getValidLocale(locale) {
  var validLocale = (_I18n2.default.manualLocale || locale || defaultLanguage).toLowerCase();
  var fallbackLookup = languageMappings[validLocale] || languageMappings[validLocale.substring(0, 2)];
  if (fallbackLookup) {
    validLocale = fallbackLookup;
  }

  return validLocale || _I18n2.default.locale;
}

function setManualOverwrites() {
  _I18n2.default.manualLocale = window.I18N_MANUAL_LANG;
  _I18n2.default.manualTimezone = window.I18N_TZ;
  try {
    var localeOverwrite = localStorage && localStorage.I18N_MANUAL_LANG;
    var timezoneOverwrite = localStorage && localStorage.I18N_TZ;
    _I18n2.default.manualLocale = localeOverwrite;
    _I18n2.default.manualTimezone = timezoneOverwrite;
  } catch (e) {
    _I18n2.default.debugLog('Failed access localStorage ' + e);
  }
}